if (!process.env.SSR) {
  require('intersection-observer-polyfill/index.global'); //eslint-disable-line
}

export * from './ComponentActionHandler';
export * from './HotAreaActionHandler';
